import { useMemo } from 'react'

import { useListTemplatesQuery } from '@axilon-apps/domains-ontology-ui-state'

export function useSandboxTemplateRegistry() {
  const templatesQuery = useListTemplatesQuery()
  return useMemo(
    () =>
      (templatesQuery.data ?? []).map((template) => ({
        path: template.path,
        code: template.code,
        defaultValues: template.default_values ?? {}
      })),
    [templatesQuery.data]
  )
}
